<template>
    <section id='personal-data'>
        <b-container fluid>
            
            <b-card title='Данные пациента'>
                <b-form>
                    <b-form-group
                        label="Имя:"
                        label-for="input-name"
                        label-cols-sm="2"
                        label-cols-lg="2"
                    >
                        <b-form-input
                            id="input-name"
                            class="w-50"
                            v-model="form.name"
                            type="text"
                            placeholder="Имя"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        label="Фамилия:"
                        label-for="input-lastname"
                        label-cols-sm="2"
                        label-cols-lg="2"
                    >
                        <b-form-input
                            id="input-lastname"
                            class="w-50"
                            v-model="form.lastname"
                            type="text"
                            placeholder="Фамилия"
                            required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group
                        label="Отчество:"
                        label-for="input-patronymic"
                        label-cols-sm="2"
                        label-cols-lg="2"
                    >
                        <b-form-input
                            id="input-patronymic"
                            class="w-50"
                            v-model="form.patronymic"
                            type="text"
                            placeholder="Отчество"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group 
                        id='radio-group-sex'
                        label="Пол:"
                        label-for="radio-sex"
                        label-cols-sm="2"
                        label-cols-lg="2"
                        v-slot="{ ariaDescribedby }"
                    >
                        <b-form-radio-group
                            id="radio-sex"
                            v-model="_sex"
                            :options="sexOptions"
                            :aria-describedby="ariaDescribedby"
                            name="radio-sex"
                            required
                        ></b-form-radio-group>
                    </b-form-group>

                    <b-form-group 
                        label="Дата рождения:"
                        label-for="datepicker-birthday"
                        label-cols-sm="2"
                        label-cols-lg="2"
                    >
                        <datepicker 
                            v-if='form.dateOfBirth'
                            id='datepicker-birthday' 
                            :value="form.dateOfBirth"
                            :language="datepickerLang"
                            format="dd.MM.yyyy"
                        ></datepicker>
                    </b-form-group>

                    <b-form-group 
                        class='d-flex'
                        label="Серия и номер паспорта:"
                        label-for="input-passport-serial"
                        label-cols-sm="2"
                        label-cols-lg="2"
                    >
                        <the-mask 
                            class="form-control w-25 d-inline-block"
                            :mask="['####']"
                            v-model="form.passportSerial"
                            type="tel"
                            placeholder="####"
                        />
                        <the-mask
                            class="form-control w-25 d-inline-block"
                            :mask="['######']"
                            v-model="form.passportNumber"
                            type="tel"
                            placeholder="######"
                        />
                        
                    </b-form-group>

   

                    <b-form-group 
                        label="Дата выдачи паспорта:"
                        label-for="datepicker-issue"
                        label-cols-sm="2"
                        label-cols-lg="2"
                    >
                        <datepicker 
                            v-if='form.dateIssuePassport'
                            id='datepicker-birthday' 
                            :value="form.dateIssuePassport"
                            :language="datepickerLang"
                            format="dd.MM.yyyy"
                        ></datepicker>
                    </b-form-group>

                    <b-form-group 
                        label="СНИЛС:"
                        label-for="masked-input-snils"
                        label-cols-sm="2"
                        label-cols-lg="2"
                    >
                        <the-mask 
                            :mask="['###-###-### ##']"
                            v-model="form.snils"
                            type="tel"
                            placeholder="###-###-### ##"
                        />
                    </b-form-group>

                    <b-form-group 
                        label="Страховой полис:"
                        label-for="input-insurance"
                        label-cols-sm="2"
                        label-cols-lg="2"
                    >
                        <b-form-input
                            id="input-insurance"
                            class="w-50"
                            v-model="form.insurance" 
                            type="text"
                            placeholder="Номер полиса медицинского страхования"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group 
                        label="Страховая компания:"
                        label-for="select-insurance-company"
                        label-cols-sm="2"
                        label-cols-lg="2"
                    >
                        <b-form-select 
                            id="select-insurance-company"
                            class="w-50"
                            v-model="form.insuranceCompany" 
                            :options="insuranceCompanyOptions"
                        ></b-form-select>
                    </b-form-group>

                    <b-form-group 
                        label="E-mail:"
                        label-for="input-email"
                        label-cols-sm="2"
                        label-cols-lg="2"
                    >
                        <b-form-input
                            id="input-email"
                            class="w-50"
                            v-model="form.email" 
                            type="email"
                            placeholder="E-mail"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group 
                        label="Тип телефона:"
                        label-for="select-phone-type"
                        label-cols-sm="2"
                        label-cols-lg="2"
                    >
                        <b-form-select 
                            class="w-50"
                            v-model="form.selectedPhoneType" 
                            :options="phoneTypeOptions"
                        ></b-form-select>
                    </b-form-group>

                    <b-form-group 
                        label="Номер телефона:"
                        label-for="masked-input-phone-number"
                        label-cols-sm="2"
                        label-cols-lg="2"
                    >
                        <the-mask 
                            :mask="['+7##########']"
                            v-model="form.phoneNumber"
                            type="tel"
                            :masked="true"
                            placeholder="+7 (###) ###-##-##"
                            required
                        />
                    </b-form-group>      

                    <b-form-group 
                        label="Тип адреса:"
                        label-for="select-address-type"
                        label-cols-sm="2"
                        label-cols-lg="2"
                    >
                        <b-form-select 
                            id="select-address-type"
                            class="w-50"
                            v-model="form.addressType" 
                            :options="addressTypeOptions"
                            required
                        ></b-form-select>
                    </b-form-group>

                    <b-form-group 
                        label="Регион проживания:"
                        label-for="select-residence-region"
                        label-cols-sm="2"
                        label-cols-lg="2"
                    >
                        <b-form-select 
                            id="select-residence-region"
                            class="w-50"
                            v-model="form.residenceRegion" 
                            :options="residenceRegionOptions"
                            required
                        ></b-form-select>
                    </b-form-group>

                    <b-form-group 
                        label="Населенный пункт:"
                        label-for="input-locality"
                        label-cols-sm="2"
                        label-cols-lg="2"
                    >
                        <b-form-input
                            id="input-locality"
                            class="w-50"
                            v-model="form.locality" 
                            type="text"
                            placeholder="Название населенного пункта"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group 
                        label="Улица:"
                        label-for="input-street"
                        label-cols-sm="2"
                        label-cols-lg="2"
                    >
                        <b-form-input
                            id="input-street"
                            class="w-50"
                            v-model="form.street" 
                            type="text"
                            placeholder="Улица"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group 
                        class='d-flex'
                        label="Дом и квартира:"
                        label-for="input-building"
                        label-cols-sm="2"
                        label-cols-lg="2"
                    >
                        <b-form-input
                            id="input-building"
                            class="d-inline-flex w-25"
                            v-model="form.building" 
                            type="text"
                            placeholder="Номер дома"
                        ></b-form-input>
                        <b-form-input
                            id="input-apartment"
                            class="d-inline-flex ml-2 w-25"
                            v-model="form.apartment" 
                            type="text"
                            placeholder="Номер квартиры"
                        ></b-form-input>
                    </b-form-group>
                    <!-- <b-button @click='concatAnswers'>Сохранить данные пациента</b-button> -->
                </b-form>
            </b-card>
        </b-container>
    </section>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex"
import Datepicker from 'vuejs-datepicker';
import { ru } from 'vuejs-datepicker/dist/locale'

export default {
    name: 'personal-data',
    components: { Datepicker },
    data() {
        return {
            datepickerLang: ru,
            answers: [],
            form: {
                name: "",
                lastname: "",
                patronymic: "",
                selectedSex: "",
                dateOfBirth: new Date(),
                passportSerial: null,
                passportNumber: null,
                dateIssuePassport: new Date(),
                snils: null,
                insurance: null,
                insuranceCompany: null,
                email: null,
                selectedPhoneType: null,
                phoneNumber: null,
                addressType: null,
                residenceRegion: 'Санкт-Петербург',
                locality: "",
                street: "",
                building: "",
                apartment: ""
            },
            sexOptions: [
                { text: 'Мужской', value: 'м' },
                { text: 'Женский', value: 'ж' }
            ],
            phoneTypeOptions: [
                { text: 'Выберите тип телефона', value: null },
                { text: 'Мобильный', value: 1 },
                { text: 'Домашний', value: 2 },
                { text: 'Другое', value: 3 },
            ],
            addressTypeOptions: [
                { text: 'Выберите тип адреса', value: null },
                { text: 'Регистрация', value: 1 },
                { text: 'Проживание', value: 2 },
            ],
            residenceRegionOptions: [
                { text: 'Санкт-Петербург', value: 1 },
                { text: 'Ленинградская область', value: 2 },
            ],
            insuranceCompanyOptions: [
                { text: 'Выберите страховую компанию', value: null },
                { text: 'ООО «СМК РЕСО-Мед»', value: 1, inn: 5035000265, id: 4198 },
                { text: 'АО «МАКС-М»', value: 2, inn: 7702030351, id: 4199 },
                { text: 'АО ``Страховая Компания ``Согаз-Мед``', value: 3, inn: 7728170427, id: 4227 },
                { text: 'ООО «Капитал МС»', value: 4, inn: 7813171100, id: 4197 },
                { text: 'АО «ГСМК»', value: 5, inn: 7825457129, id: 3553 },
                { text: 'ООО СК «Капитал-полис Мед»', value: 6, inn: 7826667390, id: 4200 },
                { text: 'Другая', value: 7, inn: 0, id: 0 },
            ]
        }
    },
    methods: {
        ...mapMutations('interview', ['SetSex', 'SetPersonal']),
        ...mapActions('interview', ['sendUserAnswers']),

        concatAnswers() {
            let cnt = 0;
            for (let [key, value] of Object.entries(this.form)) {
                if (typeof value === "number") {
                    let obj = {
                        id_question: cnt + 1,
                        int_answer: value,
                        text_answer: ""
                    }
                    this.answers.push(obj);
                    cnt += 1;
                } else {
                    if (value !== null) {
                        let obj = {
                            id_question: cnt + 1,
                            int_answer: 0,
                            text_answer: value
                        }
                        this.answers.push(obj);
                        cnt += 1;
                    }
                }
            }
            this.sendUserAnswers(this.answers);
        }
    },
    computed: {
        ...mapState({
            sex: state => state.interview.sex
        }),
        _sex: {
            get() { return this.sex },
            set(value) { 
                this.form.selectedSex = value;
                this.SetSex(value) 
            }
        },
        
    }
}
</script>

<style>
#radio-group-sex .col {
    display: flex;
}
#radio-sex {
    margin: auto 0;
}
.form-group-input-passport-number {
    margin-left: 1rem;
}
#datepicker-birthday {
    display: block;
    width: 50%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
</style>


// WEBPACK FOOTER //
// src/components/interview-components/PersonalData.vue